import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export function ContactSection() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/queries", form);
      toast.success("Query sent! Ayush will get back to you soon.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <section id="contact" className="border-t border-border py-24 md:py-36" data-testid="contact-section">
      <div className="container-px mx-auto max-w-[1600px]">
        <div className="grid gap-16 lg:grid-cols-2">
          <Reveal>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-cyan">Ask Anything</p>
            <h2 className="font-display text-5xl font-extrabold uppercase leading-none text-foreground md:text-7xl">Got a<br />question?</h2>
            <p className="mt-8 max-w-md text-muted-foreground">
              Confused about a builder, a locality, loan paperwork or taxes? Drop your query and get a straight answer — no strings attached.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <form onSubmit={submit} className="space-y-4 border border-border bg-card p-6 md:p-10" data-testid="query-form">
              <Input required data-testid="query-name" className="tool-input rounded-none" placeholder="Your name" value={form.name} onChange={set("name")} />
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <Input required type="email" data-testid="query-email" className="tool-input rounded-none" placeholder="Email" value={form.email} onChange={set("email")} />
                <Input data-testid="query-phone" className="tool-input rounded-none" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} />
              </div>
              <Textarea required data-testid="query-message" className="tool-input min-h-[140px] rounded-none" placeholder="What would you like to know?" value={form.message} onChange={set("message")} />
              <Button type="submit" disabled={loading} data-testid="query-submit" className="group w-full rounded-none bg-cyan py-6 font-mono text-xs uppercase tracking-widest text-white hover:bg-cyan/90">
                {loading ? "Sending..." : "Send Query"}
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
